import React, { useState, useEffect, useRef } from "react";

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import axios from "axios";
import moment from "moment";
import { ModalEgresosAnulados } from "./modalEgresosAnulados";
import { Input } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

const TablaEgresosAnulado = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° ORDEN",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "PROVEEDOR",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° COMPROMISO",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [aprob, setAprob] = useState(null);
  const [aprobaciones, setAprobaciones] = useState();
  const [aprodetalle, setAprodetalle] = useState();
  const [norden, setNorden] = useState(true);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idordenpago.includes(target.value) ||
              x.idcompromiso.includes(target.value) ||
              x.razonsocial.includes(target.value) ||
              moment.utc(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/administracion/registrosordenesdepagomodulo?idefiscal=${idefiscal}`;
    setActivate(true);
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data)
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarSolicitudesApro = (id) => {
    let campos = "*";
    let nomtab = "aprobaciones";
    let nomid = "idaprobaciones";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idaprobaciones > 0) {
            setAprobaciones(response.data);
            seleccionarSolicitudesAproDetalles(id);
          } else {
            setAprobaciones();
            seleccionarSolicitudesAproDetalles(id);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarSolicitudesAproDetalles = (id) => {
    let endpoint = `${op.conexion}/api/administracion/registrosordencompradetalles?id=${id}&idefiscal=${idefiscal}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setAprodetalle(response.data);
            setMostrar2(true);
          } else {
            setAprodetalle();
            setMostrar2(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
  };

  const gestionarOrdenPago = (op, data) => (e) => {
    if (op === 4) {
      setOperacion(4);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    }
  };

  useEffect(() => {
    if (espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4) {
      setNorden(false);
    }
    seleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="m-0">Egresos Anulados</h3>
        <a type="button" onClick={cerrar}>
          salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <form
        onSubmit={(e) => e.preventDefault()}
        className="col-12 p-2 m-0 d-flex justify-content-between"
      >
        <div className="col-4 m-0 p-0">
          <input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
              className='search-input form-control form-control-sm'
          />
        </div>
        <PrimaryButton
          onClick={gestionarOrdenPago(1, "")}
          icon="fa-plus m-0"
        ></PrimaryButton>
      </form>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "30px",
                    }}
                  >
                    {item.idordenpago}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "300px",
                    }}
                  >
                    {item.razonsocial}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {moment.utc(item.fecha).format("DD/MM/YYYY")}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "30px",
                    }}
                  >
                    {item.idcompromiso}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "100px",
                    }}
                  >
                    <button
                      onClick={gestionarOrdenPago(4, item)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      onClick={gestionarOrdenPago(2, item)}
                      className="btn btn-sm mx-1 btn-success rounded-pill"
                    >
                      <i className="fas fa-sync-alt"></i> Reversar
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModalEgresosAnulados
        show={mostrar2}
        operacion={operacion}
        norden={norden}
        aprobado={aprob}
        ubi={44}
        tip={0}
        aprobaciones={aprobaciones}
        aprodetalle={aprodetalle}
        titulo={
          operacion === 4
            ? "Consultar Orden Pago"
            : operacion === 2
            ? "Reversar Orden Pago"
            : operacion === 1
            ? "Incluir Orden Pago"
            : "Eliminar Orden Pago"
        }
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaEgresosAnulado;
